var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDateString, IsEmail, IsNumber, IsOptional, IsString, IsUUID, } from 'class-validator';
import { SubscriptionResponseDto } from '../../payment/dto/subscription.response.dto.js';
import { UserProfileDto } from '../../user/index.js';
/**
 * Response DTO for OfficeLocation.
 * Used for API responses - includes only the fields needed by clients.
 */
export class OfficeLocationResponseDto {
    id;
    createdAt;
    updatedAt;
    officeId;
    name;
    abbreviation;
    ownerId;
    owner;
    street;
    zip;
    town;
    countryCode;
    subdivisionCode;
    usesSeparateInvoiceAddress;
    companyNameForInvoice;
    streetForInvoice;
    zipForInvoice;
    townForInvoice;
    countryCodeForInvoice;
    registrationCode;
    profileImage;
    telephone;
    // Opening hours
    mondayFrom;
    mondayTo;
    mondayClosed;
    tuesdayFrom;
    tuesdayTo;
    tuesdayClosed;
    wednesdayFrom;
    wednesdayTo;
    wednesdayClosed;
    thursdayFrom;
    thursdayTo;
    thursdayClosed;
    fridayFrom;
    fridayTo;
    fridayClosed;
    saturdayFrom;
    saturdayTo;
    saturdayClosed;
    sundayFrom;
    sundayTo;
    sundayClosed;
    sloganLine1;
    sloganLine2;
    logoFile;
    email;
    stripeCustomerId;
    isPinoTestOfficeLocation;
    connectedStripeAccountId;
    letterheadAssetId;
    /**
     * Calendar grid interval in minutes (divisor of 60). Drives the visible grid
     * lines and the default drag snap step in the week/day calendar views.
     */
    calendarInterval;
    subscriptions;
    allowedOfficeUsers;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeLocationResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeLocationResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationResponseDto.prototype, "officeId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationResponseDto.prototype, "name", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationResponseDto.prototype, "abbreviation", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "ownerId", void 0);
__decorate([
    Type(() => UserProfileDto),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "owner", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationResponseDto.prototype, "street", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationResponseDto.prototype, "zip", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationResponseDto.prototype, "town", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationResponseDto.prototype, "countryCode", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "subdivisionCode", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationResponseDto.prototype, "usesSeparateInvoiceAddress", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "companyNameForInvoice", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "streetForInvoice", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "zipForInvoice", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "townForInvoice", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "countryCodeForInvoice", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "registrationCode", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "profileImage", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "telephone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "mondayFrom", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "mondayTo", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationResponseDto.prototype, "mondayClosed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "tuesdayFrom", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "tuesdayTo", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationResponseDto.prototype, "tuesdayClosed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "wednesdayFrom", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "wednesdayTo", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationResponseDto.prototype, "wednesdayClosed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "thursdayFrom", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "thursdayTo", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationResponseDto.prototype, "thursdayClosed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "fridayFrom", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "fridayTo", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationResponseDto.prototype, "fridayClosed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "saturdayFrom", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "saturdayTo", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationResponseDto.prototype, "saturdayClosed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "sundayFrom", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "sundayTo", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationResponseDto.prototype, "sundayClosed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "sloganLine1", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "sloganLine2", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "logoFile", void 0);
__decorate([
    IsEmail(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "stripeCustomerId", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationResponseDto.prototype, "isPinoTestOfficeLocation", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationResponseDto.prototype, "letterheadAssetId", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationResponseDto.prototype, "calendarInterval", void 0);
__decorate([
    Type(() => SubscriptionResponseDto),
    IsOptional(),
    Expose(),
    __metadata("design:type", Array)
], OfficeLocationResponseDto.prototype, "subscriptions", void 0);
__decorate([
    Type(() => UserProfileDto),
    IsOptional(),
    Expose(),
    __metadata("design:type", Array)
], OfficeLocationResponseDto.prototype, "allowedOfficeUsers", void 0);
//# sourceMappingURL=office-location.response.dto.js.map